import { IconButton } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import styled from 'styled-components'

import { blueGray, midGray } from '../../theme/colors'
import { Button } from '../Button/Button'
import { DropdownProps } from './Dropdown'
import { DropDownOpener } from './DropdownOpener'

interface MoreDropdownProps<T>
  extends Pick<
    DropdownProps<T>,
    | 'options'
    | 'isInitiallyOpen'
    | 'className'
    | 'dataTestId'
    | 'width'
    | 'align'
    | 'optionsLabel'
    | 'maxHeight'
  > {
  ariaLabel: string
  isButtonOpener?: boolean
}

interface MoreDropdownIconProps {
  dataTestId?: string
  className?: string
  ariaLabel?: string
  isButtonOpener?: boolean
}

const StyledIconButton = styled(IconButton)`
  font-size: 0;
  padding: 3px 15px;
  width: 30px;
  height: 30px;

  &:hover svg {
    color: ${midGray};
  }
`

export const StyledMoreDropdownIcon = styled(MoreVertIcon)`
  color: ${blueGray};
  cursor: pointer;
  transition: color 0.3s;
`

export function MoreDropdownIcon({
  ariaLabel,
  className,
  dataTestId,
  isButtonOpener,
}: MoreDropdownIconProps) {
  if (isButtonOpener) {
    return <Button size="medium" icon={<StyledMoreDropdownIcon />} />
  }

  return (
    <StyledIconButton aria-label={ariaLabel} className={className} data-test-id={dataTestId}>
      <StyledMoreDropdownIcon />
    </StyledIconButton>
  )
}

export function MoreDropdown<T>({
  options,
  optionsLabel,
  isInitiallyOpen,
  dataTestId,
  ariaLabel,
  className,
  width,
  maxHeight,
  align,
  isButtonOpener,
}: MoreDropdownProps<T>) {
  return (
    <DropDownOpener
      options={options}
      optionsLabel={optionsLabel}
      isInitiallyOpen={isInitiallyOpen}
      className={className}
      width={width}
      maxHeight={maxHeight}
      align={align}
    >
      {() => (
        <MoreDropdownIcon
          aria-label={ariaLabel}
          className={className}
          data-test-id={dataTestId}
          isButtonOpener={isButtonOpener}
        />
      )}
    </DropDownOpener>
  )
}
